import { Box, HStack, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { inputBorder } from '../../post advert/components/data';

export const RequestTypeCard = ({ icon, heading, text, to }) => {
  const navigate = useNavigate(to);
  return (
    <Stack
      {...inputBorder}
      px='5'
      py='8'
      cursor='pointer'
      onClick={() => navigate(to)}
    >
      <HStack>
        <Box>{icon}</Box>
        <Text fontSize='16px' fontWeight='700'>
          {heading}
        </Text>
      </HStack>
      <Text>{text}</Text>
    </Stack>
  );
};
